/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-key */
import React, { FC, BaseSyntheticEvent, useEffect, useRef, useState } from 'react'
import { fetchRigs } from './utils'
import i18n from 'live/services/i18n'
import LiveSelect from 'live/components/forms/ui/select'

interface SelectorProps extends AssetSelectorBaseProps {
    rig?: any,
}

export const RigSelector: FC<SelectorProps> = ({ onChange, rig, mode, label, placeholder, required, readOnly, validationState }) => {
    const [rigs, setRigs] = useState<any[]>([])
    const [selectedRig, setSelectedRig] = useState<any>(rig)

    const selectRig = (e: BaseSyntheticEvent, data: unknown): void => {
        if (onChange) onChange(data)
        setSelectedRig(data)
    }

    const buildLabel = () => {
        return `${ label ?? i18n('Rigs') } ${ required ? '*': '' }`
    }

    useEffect(() => {
        fetchRigs().then(response => {
            const responseArray = Object.entries(response).map(e => e[1])
            const rigs = [
                ...responseArray.map(rig => ({
                    value: rig.name,
                    label: rig.name,
                    data: {
                        id: rig.id,
                        name: rig.name
                    },
                    well: rig.state?.well?.data
                }))
            ]
            setRigs(rigs)
        })

    }, []);

    return (
        <>
            <LiveSelect
                clearable={true}
                label={buildLabel()}
                options={rigs}
                disabled={readOnly || mode === 'readOnly'}
                onBlur={() => {}}
                onChange={selectRig}
                placeholder={placeholder ?? i18n('Select a rig')}
                value={mode === 'edit' || mode === 'readOnly'? selectedRig : undefined}
                validationState={validationState}
            />
        </>
    )
}